<sui-toolbar #tb>
  @if (!singleSelectionActive && maxSelectedCount !== 1) {
    <sui-checkbox
      [checked]="selectAllChecked"
      (checkedChange)="onSelectAllChange($event)"
    >
      {{ "object-picker-actions.button.select-all" | translate }}
    </sui-checkbox>
  }

  @if (showSearch) {
    <app-search-input
      [placeholder]="'object-picker-actions.placeholder.search' | translate"
      (inputChanged)="handleInputDataObjectSearchChange($event)"
    ></app-search-input>
  }

  <sui-checkbox
    [checked]="showSelectedOnly"
    (checkedChange)="displaySelectedOnly($event)"
  >
    {{ "object-picker-actions.button.show-selected-only" | translate }}
  </sui-checkbox>

  <span class="toolbar-counter counter-{{ counterDisplayState }}">
    {{ counterText }}
  </span>

  <sui-button
    class="sort-trigger"
    variant="ghost"
    [leadingIcon]="['fas', 'sort-amount-down']"
    [trailingIcon]="['fas', 'caret-down']"
    [iconOnly]="tb.collapsed()"
    [ariaLabel]="tb.collapsed() ? sortLabel : undefined"
    [suiTooltip]="tb.collapsed() ? sortLabel : ''"
    [suiPopoverTrigger]="sortPanel"
    suiPopoverPlacement="bottom-end"
    #sortTrigger="suiPopoverTrigger"
    [expanded]="sortTrigger.isOpen()"
  >
    {{ tb.collapsed() ? "" : sortLabel }}
  </sui-button>
  <fa-icon class="sort-field-icon" [icon]="sortFieldIcon"></fa-icon>
  <ng-template #sortPanel>
    <div suiPopover class="dropdown-menu">
      <!-- Collapsed: panel gains a title (icon-only trigger has no tooltip on touch). -->
      @if (tb.collapsed()) {
        <div class="dropdown-heading">{{ sortLabel }}</div>
      }
      <div
        sui-radio-group
        orientation="vertical"
        [ngModel]="sortField"
        [ngModelOptions]="{ standalone: true }"
        (valueChange)="onSortFieldChange($any($event))"
      >
        <sui-radio
          class="dropdown-item"
          indicatorPosition="trailing"
          value="title"
        >
          <fa-icon [icon]="['fas', 'text-height']"></fa-icon>
          <span>{{ "dataobject-list-actions.button.title" | translate }}</span>
        </sui-radio>
        <sui-radio
          class="dropdown-item"
          indicatorPosition="trailing"
          value="time_created"
        >
          <fa-icon [icon]="['fas', 'clock']"></fa-icon>
          <span>{{
            "dataobject-list-actions.button.created-time" | translate
          }}</span>
        </sui-radio>
        <sui-radio
          class="dropdown-item"
          indicatorPosition="trailing"
          value="time_modified"
        >
          <fa-icon [icon]="['fas', 'clock']"></fa-icon>
          <span>{{
            "dataobject-list-actions.button.modified-time" | translate
          }}</span>
        </sui-radio>
      </div>

      <div class="dropdown-divider"></div>

      <div
        sui-radio-group
        orientation="vertical"
        [ngModel]="sortDirection"
        [ngModelOptions]="{ standalone: true }"
        (valueChange)="onSortDirectionChange($any($event))"
      >
        <sui-radio
          class="dropdown-item"
          indicatorPosition="trailing"
          value="asc"
        >
          <fa-icon [icon]="['fas', 'sort-amount-up']"></fa-icon>
          <span>{{
            "dataobject-list-actions.button.ascending" | translate
          }}</span>
        </sui-radio>
        <sui-radio
          class="dropdown-item"
          indicatorPosition="trailing"
          value="desc"
        >
          <fa-icon [icon]="['fas', 'sort-amount-down']"></fa-icon>
          <span>{{
            "dataobject-list-actions.button.descending" | translate
          }}</span>
        </sui-radio>
      </div>
    </div>
  </ng-template>
</sui-toolbar>

@if (
  {
    loading: objectsLoading$ | async,
    objects: updatedFilteredObjects,
  };
  as data
) {
  <div class="scrollable-content">
    @if (data.loading) {
      <app-loading></app-loading>
    }
    @if (data.objects?.length === 0 && !data.loading) {
      <div class="empty-state-message">
        {{ getEmptyMessage(objectClassIds) }}
      </div>
    }
    @if (resultsCapped && !data.loading) {
      <p class="capped-note">
        {{
          "dataobject-list.notice.showing-the-first-count-objects-refine-your-search"
            | translate: { count: resultsCap }
        }}
      </p>
    }
    @if (data.objects?.length > 0) {
      <div class="card-container mb-containers">
        @for (object of data.objects; track trackByFn($index, object)) {
          <app-object-card
            (onObjectSelect)="toggleSelection($event)"
            [selected]="isSelected(object)"
            [selectMode]="true"
            [object]="object"
            [filterString]="searchString"
            [titleCharLimit]="40"
          ></app-object-card>
        }
      </div>
    }
  </div>
}
